import { GlobalHelp, HelpProvider } from "./components/help"
import { AuthProvider } from "./contexts/AuthContext"

import Routes from "./routes"

function App() {
    return (
        <AuthProvider>
            <HelpProvider>
                <Routes />
                <GlobalHelp />
            </HelpProvider>
        </AuthProvider>
    )
}

export default App
